export default {
    methods: {
        pushIncrements: function(minRounded, maxRounded, incrementMax, increment, array) {
            for (let i = minRounded; i <= incrementMax; i += increment) {
                if (i > maxRounded) {
                    return;
                } else {
                    array.push(i);
                }
            }
        },
        getNextMultiple: function(number, multiple) {
            return (Math.ceil(number / multiple) * multiple);
        },
        getPreviousMultiple: function(number, multiple) {
            return (Math.floor(number / multiple) * multiple);
        },
    }
}